import moment from 'moment';
import db from '@/store/db';
import log from '@/logger';

export default {
  getDefaultStage: (projectId) => {
    return {
      title: 'New Stage',
      projectId: projectId,
      type: 'Stage',
      children: [],
      showChildren: true,
      show: true,
      archived: false,
      lastUpdate: {},
      colour: '#000099',
      lockedDragNDrop: false,
      stageOccupation: '',
      stageManagerId: '',
      lockedDiary: false,
      createdAt: moment().format(),
    };
  },
  createStage: function (projectId, properties) {
    var newStage = this.getDefaultStage(projectId);
    if (properties) {
      Object.assign(newStage, properties);
      // newStage.title = properties.title;
    }

    // In case we copy a whole other stage..
    delete newStage._id;
    delete newStage._rev;

    return db.currentProjectDb.post(newStage).then((doc) => {
      newStage._id = doc.id;
      newStage._rev = doc.rev;
      return Promise.resolve(newStage);
    });
  },
  saveStage: function (stage) {
    return new Promise((resolve, reject) => {
      var savedStage = {};
      if (stage._id) {
        return db.currentProjectDb.put(stage).then((response) => {
          savedStage._rev = response.rev;
          resolve(savedStage);
        });
      } else {
        return db.currentProjectDb.post(stage).then((response) => {
          savedStage._id = response.id;
          savedStage._rev = response.rev;
          resolve(savedStage);
        });
      }
    });
  },

  getStages: async function (projectId) {
    return db.loadedDatabases[projectId]
      .query('stages', {
        include_docs: true,
        startkey: [projectId, ''],
        endkey: [projectId, '\ufff0'],
      })
      .then((result) => {
        var populated = {};
        for (let stage of result.rows) {
          let loadedStage = Object.assign(this.getDefaultStage(projectId), stage.doc);
          populated[loadedStage._id] = loadedStage;
        }
        return populated;
      })
      .catch(function (err) {
        log.error('Unable to load stages', err);
      });
  },
};



// WEBPACK FOOTER //
// ./src/store/stage/stageApi.js